import { Link } from "react-router-dom";

export default function Company() {
    return (
        <main data-testid="company-page" className="pt-[72px]">
            <section className="bg-[#0B1930] text-white pt-24 pb-24 relative overflow-hidden grain">
                <div className="hero-glow top-[-30%] right-[10%]" style={{ background: "#2563EB" }} />
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                    <div className="eyebrow">Company</div>
                    <h1 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 max-w-3xl">
                        Software that makes <em className="not-italic text-[#E8B923]">business simpler.</em>
                    </h1>
                </div>
            </section>
            <section className="py-20 max-w-[1000px] mx-auto px-6 lg:px-10 space-y-12">
                <p className="text-lg leading-relaxed text-slate-600">
                    Colecle Inc builds practical digital solutions that automate business processes, improve operational visibility, strengthen control and help organizations work smarter. From ministries and financial institutions to enterprises, property portfolios and event organizers — Colecle is one platform, five products, and countless outcomes.
                </p>
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-[#F7F9FC] border border-slate-200 rounded-2xl p-8">
                        <div className="eyebrow eyebrow--slate">Mission</div>
                        <h3 className="font-serif text-2xl text-navy mt-3">Digital solutions that make business simpler.</h3>
                    </div>
                    <div className="bg-[#F7F9FC] border border-slate-200 rounded-2xl p-8">
                        <div className="eyebrow eyebrow--slate">Vision</div>
                        <h3 className="font-serif text-2xl text-navy mt-3">One platform. Smarter business — everywhere.</h3>
                    </div>
                </div>
                <div className="pt-8">
                    <Link to="/support" className="btn-primary">Contact us</Link>
                </div>
            </section>
        </main>
    );
}
